import React from "react";

const DomainTestPercentage: React.FC<any> = ({
  colour,
  percent,
  isAdditional,
}: {
  colour: string;
  percent: number;
  isAdditional: boolean;
}) => {
  return (
    <div
      className="h-4 relative"
      style={{
        display: `${percent == 0 ? "none" : ""}`,
        width: `${percent < 3 ? 3 : percent}%`,
        backgroundColor: `${colour}`,
      }}
    >
      {!isAdditional && (
        <span className="text-sm absolute -top-5 right-0 font-medium">
          {percent} {" %"}
        </span>
      )}
    </div>
  );
};

export default DomainTestPercentage;
